import { ENV } from 'config/env';

/**
 * Helper that lets every service support a mock mode with zero coupling to the
 * UI. While REACT_APP_USE_MOCK=true, services resolve local JSON instead of
 * hitting the network. Flipping the env flag (or replacing the service method
 * body) is the ONLY change needed to switch to the real FastAPI backend.
 */
export const isMockEnabled = () => ENV.USE_MOCK;

/** Resolve a value after a small artificial delay to mimic latency. */
export const mockResponse = (data, delay = 350) =>
  new Promise((resolve) => setTimeout(() => resolve(structuredCloneSafe(data)), delay));

/** Reject with an Axios-like error shape so errorParser handles it uniformly. */
export const mockError = (status, message, delay = 300) =>
  new Promise((_, reject) =>
    setTimeout(
      () =>
        reject({
          response: { status, data: { detail: message } },
          isMock: true,
        }),
      delay
    )
  );

const structuredCloneSafe = (data) => {
  try {
    return typeof structuredClone === 'function' ? structuredClone(data) : JSON.parse(JSON.stringify(data));
  } catch {
    return data;
  }
};

const mockAdapter = { isMockEnabled, mockResponse, mockError };

export default mockAdapter;
